var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle113A = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 106",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M9.5 99H44l.725-7.251A2.5 2.5 0 0 0 42.237 89H19.5a2.5 2.5 0 0 1-2.5-2.5V11.861a2.5 2.5 0 0 0-2.835-2.477L7 10.353V96.5A2.5 2.5 0 0 0 9.5 99Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M7 9v87.5A2.5 2.5 0 0 0 9.5 99H45"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M54 9v10l-8.273.752A2.5 2.5 0 0 1 43 17.262v-6.525a2.5 2.5 0 0 1 2.726-2.49L54 9Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m52 8 .446.222A2.813 2.813 0 0 1 54 10.738v6.523c0 1.066-.602 2.04-1.555 2.516L52 20"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M54 25v10l-8.273.752A2.5 2.5 0 0 1 43 33.262v-6.525a2.5 2.5 0 0 1 2.726-2.49L54 25Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m52 24 .446.222A2.812 2.812 0 0 1 54 26.738v6.523c0 1.066-.602 2.04-1.555 2.516l-.445.222"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M54 41v10l-8.273.752A2.5 2.5 0 0 1 43 49.262v-6.525a2.5 2.5 0 0 1 2.726-2.49L54 41Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m52 40 .446.222A2.812 2.812 0 0 1 54 42.738v6.523c0 1.066-.602 2.04-1.555 2.516l-.445.222"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M54 57v10l-8.273.752A2.5 2.5 0 0 1 43 65.262v-6.524a2.5 2.5 0 0 1 2.726-2.49L54 57Z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m52 56 .446.223A2.813 2.813 0 0 1 54 58.738v6.524c0 1.065-.602 2.039-1.555 2.515L52 68"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M54 73v10l-8.273.752A2.5 2.5 0 0 1 43 81.262v-6.524a2.5 2.5 0 0 1 2.726-2.49L54 73Z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m52 72 .446.223A2.813 2.813 0 0 1 54 74.738v6.524c0 1.065-.602 2.039-1.555 2.515L52 84"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M37.5 6A2.5 2.5 0 0 1 40 8.5v75a2.5 2.5 0 0 1-2.5 2.5h-15a2.5 2.5 0 0 1-2.5-2.5v-75A2.5 2.5 0 0 1 22.5 6h15Z"
})));
SvgRectangle113A.viewBox = '0 0 60 106';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangle113A);
export default ForwardRef;